import { z } from 'zod';
import { order } from '@schuettflix/schema-registry-ts';

export const FulfillmentProductFulfilledEventSchema =
    order.fulfillmentService.versions.v1.schemas.FULFILLMENT_PRODUCT_FULFILLED;
export type FulfillmentProductFulfilledEventPayload = z.infer<typeof FulfillmentProductFulfilledEventSchema>;
